import * as order from '@/views/Order/constants'
import * as budget from '@/views/Budget/constants'
// import * as customer from '@/views/Customer/constants'
// ...adiciona novos módulos aqui quando criar

export const CONSTANTS = Object.freeze({
  order,
  budget,
  // customer,
})
